export const DRIVE_ITEM_LIST_PAGE_SIZE = 20;

export enum DriveItemListDisplayType {
	Masonry = 'Masonry',
	Grid = 'Grid',
	Row = 'Row'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/constants.ts